/**
 * @fileoverview gRPC-Web generated client stub for pb
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v5.29.1
// source: proto/products.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.pb = require('./products_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.pb.ProductServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.pb.ProductServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pb.ListProductsRequest,
 *   !proto.pb.ListProductsResponse>}
 */
const methodDescriptor_ProductService_ListProducts = new grpc.web.MethodDescriptor(
  '/pb.ProductService/ListProducts',
  grpc.web.MethodType.UNARY,
  proto.pb.ListProductsRequest,
  proto.pb.ListProductsResponse,
  /**
   * @param {!proto.pb.ListProductsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.pb.ListProductsResponse.deserializeBinary
);


/**
 * @param {!proto.pb.ListProductsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pb.ListProductsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pb.ListProductsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pb.ProductServiceClient.prototype.listProducts =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pb.ProductService/ListProducts',
      request,
      metadata || {},
      methodDescriptor_ProductService_ListProducts,
      callback);
};


/**
 * @param {!proto.pb.ListProductsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pb.ListProductsResponse>}
 *     Promise that resolves to the response
 */
proto.pb.ProductServicePromiseClient.prototype.listProducts =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pb.ProductService/ListProducts',
      request,
      metadata || {},
      methodDescriptor_ProductService_ListProducts);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pb.Product,
 *   !proto.pb.Product>}
 */
const methodDescriptor_ProductService_CreateProduct = new grpc.web.MethodDescriptor(
  '/pb.ProductService/CreateProduct',
  grpc.web.MethodType.UNARY,
  proto.pb.Product,
  proto.pb.Product,
  /**
   * @param {!proto.pb.Product} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.pb.Product.deserializeBinary
);


/**
 * @param {!proto.pb.Product} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pb.Product)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pb.Product>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pb.ProductServiceClient.prototype.createProduct =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pb.ProductService/CreateProduct',
      request,
      metadata || {},
      methodDescriptor_ProductService_CreateProduct,
      callback);
};


/**
 * @param {!proto.pb.Product} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pb.Product>}
 *     Promise that resolves to the response
 */
proto.pb.ProductServicePromiseClient.prototype.createProduct =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pb.ProductService/CreateProduct',
      request,
      metadata || {},
      methodDescriptor_ProductService_CreateProduct);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pb.ProductId,
 *   !proto.pb.Product>}
 */
const methodDescriptor_ProductService_DeleteProduct = new grpc.web.MethodDescriptor(
  '/pb.ProductService/DeleteProduct',
  grpc.web.MethodType.UNARY,
  proto.pb.ProductId,
  proto.pb.Product,
  /**
   * @param {!proto.pb.ProductId} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.pb.Product.deserializeBinary
);


/**
 * @param {!proto.pb.ProductId} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pb.Product)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pb.Product>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pb.ProductServiceClient.prototype.deleteProduct =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pb.ProductService/DeleteProduct',
      request,
      metadata || {},
      methodDescriptor_ProductService_DeleteProduct,
      callback);
};


/**
 * @param {!proto.pb.ProductId} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pb.Product>}
 *     Promise that resolves to the response
 */
proto.pb.ProductServicePromiseClient.prototype.deleteProduct =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pb.ProductService/DeleteProduct',
      request,
      metadata || {},
      methodDescriptor_ProductService_DeleteProduct);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pb.Product,
 *   !proto.pb.Product>}
 */
const methodDescriptor_ProductService_UpdateProduct = new grpc.web.MethodDescriptor(
  '/pb.ProductService/UpdateProduct',
  grpc.web.MethodType.UNARY,
  proto.pb.Product,
  proto.pb.Product,
  /**
   * @param {!proto.pb.Product} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.pb.Product.deserializeBinary
);


/**
 * @param {!proto.pb.Product} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pb.Product)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pb.Product>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pb.ProductServiceClient.prototype.updateProduct =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pb.ProductService/UpdateProduct',
      request,
      metadata || {},
      methodDescriptor_ProductService_UpdateProduct,
      callback);
};


/**
 * @param {!proto.pb.Product} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pb.Product>}
 *     Promise that resolves to the response
 */
proto.pb.ProductServicePromiseClient.prototype.updateProduct =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pb.ProductService/UpdateProduct',
      request,
      metadata || {},
      methodDescriptor_ProductService_UpdateProduct);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pb.SendEmailRequest,
 *   !proto.pb.SendEmailResponse>}
 */
const methodDescriptor_ProductService_SendEmail = new grpc.web.MethodDescriptor(
  '/pb.ProductService/SendEmail',
  grpc.web.MethodType.UNARY,
  proto.pb.SendEmailRequest,
  proto.pb.SendEmailResponse,
  /**
   * @param {!proto.pb.SendEmailRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.pb.SendEmailResponse.deserializeBinary
);


/**
 * @param {!proto.pb.SendEmailRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pb.SendEmailResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pb.SendEmailResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pb.ProductServiceClient.prototype.sendEmail =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pb.ProductService/SendEmail',
      request,
      metadata || {},
      methodDescriptor_ProductService_SendEmail,
      callback);
};


/**
 * @param {!proto.pb.SendEmailRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pb.SendEmailResponse>}
 *     Promise that resolves to the response
 */
proto.pb.ProductServicePromiseClient.prototype.sendEmail =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pb.ProductService/SendEmail',
      request,
      metadata || {},
      methodDescriptor_ProductService_SendEmail);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pb.InitialDeliveryRequest,
 *   !proto.pb.InitialDeliveryResponse>}
 */
const methodDescriptor_ProductService_GetInitialDelivery = new grpc.web.MethodDescriptor(
  '/pb.ProductService/GetInitialDelivery',
  grpc.web.MethodType.UNARY,
  proto.pb.InitialDeliveryRequest,
  proto.pb.InitialDeliveryResponse,
  /**
   * @param {!proto.pb.InitialDeliveryRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.pb.InitialDeliveryResponse.deserializeBinary
);


/**
 * @param {!proto.pb.InitialDeliveryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pb.InitialDeliveryResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pb.InitialDeliveryResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pb.ProductServiceClient.prototype.getInitialDelivery =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pb.ProductService/GetInitialDelivery',
      request,
      metadata || {},
      methodDescriptor_ProductService_GetInitialDelivery,
      callback);
};


/**
 * @param {!proto.pb.InitialDeliveryRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pb.InitialDeliveryResponse>}
 *     Promise that resolves to the response
 */
proto.pb.ProductServicePromiseClient.prototype.getInitialDelivery =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pb.ProductService/GetInitialDelivery',
      request,
      metadata || {},
      methodDescriptor_ProductService_GetInitialDelivery);
};


module.exports = proto.pb;

